/**
 * Generated by orval v8.23.0 🍺
 * Do not edit manually.
 * Arbi API
 * OpenAPI spec version: 1.0.0
 */

/**
 * The org's square logo, centred in the templated tile when there is no full-frame artwork.
 * Stored normalised: a PNG with alpha, at most 512×512.
 */
export interface BotLogoOut {
  url: string;
  hash: string;
  bytes: number;
  width: number;
  height: number;
}
